import { render, staticRenderFns } from "./label_manage.vue?vue&type=template&id=1a2b2eee&scoped=true"
import script from "./label_manage.vue?vue&type=script&lang=js"
export * from "./label_manage.vue?vue&type=script&lang=js"
import style0 from "./label_manage.vue?vue&type=style&index=0&id=1a2b2eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b2eee",
  null
  
)

export default component.exports